import { render, staticRenderFns } from "./Notazz.vue?vue&type=template&id=21db18ac&scoped=true&"
import script from "./Notazz.vue?vue&type=script&lang=js&"
export * from "./Notazz.vue?vue&type=script&lang=js&"
import style0 from "./Notazz.vue?vue&type=style&index=0&id=21db18ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21db18ac",
  null
  
)

export default component.exports